import { ReactElement } from "react";
import { createRoot } from "react-dom/client";
import { PlusMenu } from "client/Features/ItemCreation/PlusMenu";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import { MainMenuItem, useMainMenuStore } from "../mainMenuStore";
import { shallowComparison } from "client/Misc/compareUtils";

export const MainMenuActions = (): ReactElement => {
	const isResponsive: boolean = useWorkspaceMediaQuery(MediaQueryKind.Responsive);

	const {
		activeItem,
		deactivateItem
	} = useMainMenuStore(
		x => ({
			activeItem: x.activeItem,
			deactivateItem: x.deactivateItem
		}),
		shallowComparison
	);

	return (
		<>
			{activeItem === MainMenuItem.CreateItem && (
				isResponsive
					? null
					: <PlusMenu onClose={() => deactivateItem(MainMenuItem.CreateItem)} />
			)}
		</>
	);
};
MainMenuActions.displayName="MainMenuActions";

export function renderMainMenuActions(host: HTMLElement): void {
	createRoot(host)
		.render(<MainMenuActions />);
}
